const removeSpaces = (text?: string): string | undefined => text?.replace(/\s/g, '');

export default removeSpaces;
